import { UserModelJsonResource } from "@/types/userTypes";
import api from "./axios";

/**
 * Settings API functions for managing user preferences and profile settings
 */
export class ExerciseApi {
  /**
   * Update user preferences (weight unit and date range)
   * @param preferences - The preferences to update
   * @returns The updated user data
   */
  async updateExerciseAttributes(
    exerciseNanoId: string,
    name: string
  ): Promise<UserModelJsonResource> {
    const response = await api.post(
      `/api/exercise/${exerciseNanoId}/attributes`,
      {
        name,
      }
    );
    return response.data;
  }
}

export const exerciseApi = new ExerciseApi();
